import { wrapOrUnwrap } from '../markingUtils'
import type { RefObject } from 'react'
import { applyChange } from '../utils'

const toggleMarkingAction =
  (wrapper: string) =>
  (
    textareaRef: RefObject<HTMLTextAreaElement>,
    value: string,
    onChange: (val: string) => void,
  ): boolean => {
    const el = textareaRef.current
    if (!el) return false
    const s = el.selectionStart ?? 0
    const e = el.selectionEnd ?? s
    const { value: next, start, end } = wrapOrUnwrap(value, s, e, wrapper)
    applyChange(textareaRef, onChange, next, start, end)
    return true
  }

export const toggleBoldAction = toggleMarkingAction('**')

export const toggleItalicAction = toggleMarkingAction('*')

export const toggleStrikeAction = toggleMarkingAction('~~')

export const toggleInlineCodeAction = toggleMarkingAction('`')
